var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.785,
    height: 23.276,
    viewBox: "0 0 19.785 23.276",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Location",
    d: "M9.9,23.276a1.58,1.58,0,0,1-.854-.288A25.037,25.037,0,0,1,2.6,17.005,12.086,12.086,0,0,1,0,9.681,9.506,9.506,0,0,1,2.913,2.833,9.928,9.928,0,0,1,9.885,0a9.8,9.8,0,0,1,9.9,9.681,12.092,12.092,0,0,1-2.6,7.325,25.511,25.511,0,0,1-6.449,5.983A1.536,1.536,0,0,1,9.9,23.276ZM9.885,6.724A3.262,3.262,0,0,0,6.627,9.982a3.156,3.156,0,0,0,.956,2.275,3.286,3.286,0,0,0,5.575-2.275A3.287,3.287,0,0,0,9.885,6.724Z",
    fill: "#bbb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.1e602f871568f38fc8902eba95f8a80b.svg";
export { ForwardRef as ReactComponent };